const IndexComponent = () => import('../pages/index/index.vue')
const LoginComponent = () => import('../pages/login/index.vue')

export default [
  {
    path: '/login',
    name: '',
    meta: { keepAlive: true, isTab: false },
    component: LoginComponent
  },
  {
    path: '/register',
    name: '注册新公司',
    meta: { keepAlive: true, isTab: false },
    component: () => import('../pages/register/index.vue')
  },
  {
    path: '/reset-password',
    name: '找回密码',
    meta: { keepAlive: true, isTab: false },
    component: () => import('../pages/reset-password/index.vue')
  },
  {
    path: '/404',
    component: () => import('../pages/404.vue'),
    name: '404',
    meta: {
      keepAlive: true,
      isTab: false
    }
  },
  { path: '', redirect: '/wel/index' },
  {
    path: '/wel/index',
    name: 'home-page',
    meta: { isAuth: true, keepAlive: true },
    component: IndexComponent,
    children: [
      {
        path: '',
        name: '首页',
        meta: { keepAlive: true },
        component: () => import('../views/home/index.vue')
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/404'
  },
  {
    path: '/third-icons',
    name: '图标页',
    meta: { keepAlive: true, isTab: false },
    component: () => import('../pages/third-icons/index.vue')
  },
  {
    path: '/doc',
    name: '海竣信息管理系统帮助文档',
    component: () => import('../pages/help-doc/index.vue'),
    meta: {
      keepAlive: true,
      isTab: false,
      isAuth: false
    }
  }
]
